import cn from "classnames";

import {Text} from "@pg-design/text-module";

import {weekdaysShortcuts} from "../constants/weekdays_shortcuts";
import type {ICalendarDate} from "../types/ICalendarDate";

import * as styles from "./CalendarCard.module.css";

interface IProps {
    dayData: ICalendarDate;
    onClick: (day: ICalendarDate) => void;
    isSelected?: boolean;
}

export const CalendarCard = (props: IProps) => {
    //Months are numbered from 0 so actual month in numeric presentation need incrementation by 1
    const dayString = `${weekdaysShortcuts[props.dayData.dayId]} ${props.dayData.day}.${props.dayData.month + 1}`;

    return (
        <div className={cn(styles.calendarCard, props.isSelected && styles.calendarCardActive)} onClick={() => props.onClick(props.dayData)}>
            <Text variant="info_txt_1">{dayString}</Text>
        </div>
    );
};
import cn from "classnames";

import {Text} from "@pg-design/text-module";

import {weekdaysShortcuts} from "../constants/weekdays_shortcuts";
import type {ICalendarDate} from "../types/ICalendarDate";

import * as styles from "./CalendarCard.module.css";

interface IProps {
    dayData: ICalendarDate;
    onClick: (day: ICalendarDate) => void;
    isSelected?: boolean;
}

export const CalendarCard = (props: IProps) => {
    //Months are numbered from 0 so actual month in numeric presentation need incrementation by 1
    const dayString = `${weekdaysShortcuts[props.dayData.dayId]} ${props.dayData.day}.${props.dayData.month + 1}`;

    return (
        <div className={cn(styles.calendarCard, props.isSelected && styles.calendarCardActive)} onClick={() => props.onClick(props.dayData)}>
            <Text variant="info_txt_1">{dayString}</Text>
        </div>
    );
};
